import React, { useEffect, useState } from "react";
import ListOfUserGroup from "./ListOfUserGroup";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import { fetchData } from "./Utilities";

const UsersTreeView = ({ setShowAllocation, onClosed }) => {
  const [treeValues, setTreeValues] = useState({});
  const [userList, setUserList] = useState([]);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: 20,
  });

  const fetchChildrenData = async (uid) => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    bodyFormData.append("uid", uid);
    try {
      const response = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          "Content-type": "multipart/form-date",
          Accept: "application/json",
          cmd: "referrallist",
        },
      });
      if (response.status === 200) {
        const data = await response;
        return data?.data?.dt?.map((childItem) => ({
          key: childItem.uid,
          label: `${childItem.Name} ${childItem.Family} (${childItem.referral})`,
        }));
      } else {
        console.error(`API request failed with status: ${response.status}`);
        return [];
      }
    } catch (error) {
      console.error("Error while fetching children data:", error);
      return [];
    }
  };

  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("guid", Cookies.get("guid"));
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    bodyFormData.append("uid", 0);
    fetchData("userlist", bodyFormData, handleApiResponse);
  }, [lazyState]);
// let userCount = null;
const [userCount,setUserCount] = useState('')
  const handleApiResponse = async (data) => {
  
    setUserCount(data?.count)

    const mappedOptionsPromises = data?.dt?.map(async (item) => {
      const children =
        item.referral >= 1 ? await fetchChildrenData(item.uid) : "";
      return {
        ...item,
        key: item.uid,
        label: `${item.Name} ${item.Family} (${item.referral})`,
        children,
      };
    });
    const mappedOptions = await Promise.all(mappedOptionsPromises);
    console.log(mappedOptions)
    const parent = [
      {
        label: `تاب30 (تعداد کاربران${mappedOptions.length})`,
        key: 0,
        children: mappedOptions,
      },
    ];
    setUserList(parent);
  };
  return (
    <>
    <div className="d-flex justify-content-start align-items-center">
    <p>مجموع تعداد کاربران تاب30</p>
    <p className="btn  btn-success mx-2">{userCount}</p>
    </div>
    <ListOfUserGroup
      list={userList}
      onChange={setTreeValues}
      value={treeValues}
      />
      </>
  );
};

export default UsersTreeView;
